import React from "react";
import { useState } from "react";
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import { useUserInfor } from "../../../../../Context/User";
import { ListarProdutosPorContaCompleto } from "../../../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import { AtualizarAtendimentoController } from "../../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListarCategoriaAtendimentoAoClienteController } from "../../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import { ListarSubCategoriaController } from "../../../../../Controllers/Geral/GestaoDeCadastros/SubCategoria/SubCategoriaControllers";
import { ListarCanalAtendimentoContoller } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import { ListarTipoPesoAtendimentoAtivosController } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { IContaProduto } from "../../../../../Interfaces/Cobranca/ContaProduto/ContaProdutoInterface";
import { IAtualizarAtendimento } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { Spinner } from "../../../../Loding/SpinnerPadrao";
import LazySelect from "../../../Forms/LazySelect";
import SelectCategoriaAtendimento from "../../../Forms/SelectCategoriaAtendimento";

const controllers = {
    Atendimento: {
        Categoria: ListarCategoriaAtendimentoAoClienteController,
        Subcateogoria: ListarSubCategoriaController,
        Produto: ListarProdutosPorContaCompleto,
        id: ACESSOS.ATENDIMENTO.ID_MODULO,
    },
};

interface IEditarAtendimentoProps {
    setShow: (show: boolean) => void;
}

export default function EditarAtendimento(props: IEditarAtendimentoProps) {
    const { ReloadHistorico } = useHistoricoContext();
    const { UserInfor } = useUserInfor();

    const { Atendimento, TIPO_CASO, updateAtendimento, idModulo } =
        useAtendimentoPage();

    const formMethods = useForm();

    const { handleSubmit } = formMethods;
    const [produtos, setProdutos] = useState<Array<IContaProduto>>([]);

    const ListarProdutosCliente = useCallback(
        async () =>
            TIPO_CASO === "Atendimento" && Atendimento?.ID_CONTA
                ? controllers[TIPO_CASO].Produto(
                      Atendimento?.ID_CONTA,
                      idModulo
                  )
                : ([] as Array<IContaProduto>),
        [Atendimento?.ID_CONTA, TIPO_CASO, idModulo]
    );
    const ListarSubCategorias = useCallback(
        async (idCategoria: number, idUnidade: number) => {
            const idEmpreendimento = produtos.find(
                (p) => p.UNIDADE.ID_UNIDADE === idUnidade
            )?.ID_EMPREENDIMENTO;
            return ListarSubCategoriaController(idCategoria, idEmpreendimento);
        },
        [produtos]
    );

    const { loading: atualizando, execute: handleEditarAtendimentoFormSubmit } =
        useAsyncCallback(async (formdata: IAtualizarAtendimento) => {
            if (Atendimento?.ID_CASO) {
                await AtualizarAtendimentoController(Atendimento.ID_CASO, {
                    ...formdata,
                    ID_TIPO_CASO: idModulo,
                }).then(() => {
                    props.setShow(false);
                    updateAtendimento();
                    ReloadHistorico();
                });
            }
        });
    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    return (
        <form onSubmit={handleSubmit(handleEditarAtendimentoFormSubmit)}>
            {TIPO_CASO === "Atendimento" && (
                <LazySelect
                    label="Produto"
                    name="ID_PRODUTO"
                    controller={ListarProdutosCliente}
                    defaultValue={Atendimento?.ID_PRODUTO}
                    getDS={(p) =>
                        `${p.DS_EMPREENDIMENTO} - ${p.UNIDADE.DS_UNIDADE}`
                    }
                    getKeyValue={(p) => p.UNIDADE.ID_UNIDADE}
                    {...formMethods}
                    registerOptions={{
                        required: "Insira o produto",
                        valueAsNumber: true,
                    }}
                    onOptionsLoad={setProdutos}
                    className="form-control mb-2"
                />
            )}
            <label>Categoria de Atendimento</label>
            <SelectCategoriaAtendimento
                name="ID_CATEGORIA_ATENDIMENTO"
                ID_MODULO={idModulo}
                defaultValue={Atendimento?.ID_CATEGORIA_ATENDIMENTO}
                control={formMethods.control}
                rules={{
                    required: "Insira a categoria de Atendimento",
                }}
                className="form-control mb-2"
            />
            {TIPO_CASO === "Atendimento" && (
                <LazySelect
                    label="Subcategoria"
                    name="ID_SUBCATEGORIA_ATENDIMENTO"
                    parentsNames={["ID_CATEGORIA_ATENDIMENTO", "ID_PRODUTO"]}
                    controller={ListarSubCategorias}
                    defaultValue={Atendimento?.ID_SUBCATEGORIA_ATENDIMENTO}
                    getDS={(s) => s.DS_SUBCATEGORIA_ATENDIMENTO}
                    getKeyValue={(s) => s.ID_SUB_CATEGORIA_ATENDIMENTO}
                    {...formMethods}
                    registerOptions={{
                        valueAsNumber: true,
                    }}
                    className="form-control mb-2"
                >
                    <option value={0}></option>
                </LazySelect>
            )}
            {TIPO_CASO !== "Cobranca" && (
                <LazySelect
                    label="Peso"
                    name="ID_TIPO_PESO_ATENDIMENTO"
                    controller={ListarTipoPesoAtendimentoAtivosController}
                    getDS={(p) => p.DS_TIPO_PESO_ATENDIMENTO}
                    getKeyValue={(p) => p.ID_TIPO_PESO_ATENDIMENTO}
                    defaultValue={Atendimento?.ID_TIPO_PESO_ATENDIMENTO}
                    disabled={
                        !UserInfor.FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_EDITA_PESO_ATENDIMENTO"
                        )
                    }
                    {...formMethods}
                    registerOptions={{
                        valueAsNumber: true,
                    }}
                    className="form-control mb-2"
                >
                    <option value={0}></option>
                </LazySelect>
            )}

            <LazySelect
                label="Canal de Atendimento"
                name="ID_TIPO_CANAL_ATENDIMENTO"
                controller={listarCanalAtendimento}
                defaultValue={Atendimento?.ID_TIPO_CANAL_ATENDIMENTO}
                getDS={(c) => c.DS_TIPO_CANAL_ATENDIMENTO}
                getKeyValue={(c) => c.ID_TIPO_CANAL_ATENDIMENTO}
                {...formMethods}
                registerOptions={{
                    required: "Insira o Canal de Atendimento",
                    valueAsNumber: true,
                }}
                className="form-control mb-2"
            />

            <div className="d-flex mt-5">
                <button
                    type="submit"
                    className="btn btn-block btn-outline-success d-flex align-items-center justify-content-center g-2"
                    disabled={atualizando}
                >
                    {atualizando && <Spinner size="sm" />}
                    Confirmar atualização
                </button>
            </div>
        </form>
    );
}
